import { render, staticRenderFns } from "./quick-note.vue?vue&type=template&id=84ff859a&scoped=true&"
import script from "./quick-note.vue?vue&type=script&lang=js&"
export * from "./quick-note.vue?vue&type=script&lang=js&"
import style0 from "./quick-note.vue?vue&type=style&index=0&id=84ff859a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ff859a",
  null
  
)

export default component.exports